import { render, staticRenderFns } from "./IntroductionHome.vue?vue&type=template&id=581066e4&scoped=true&"
import script from "./IntroductionHome.vue?vue&type=script&lang=js&"
export * from "./IntroductionHome.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionHome.vue?vue&type=style&index=0&id=581066e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581066e4",
  null
  
)

export default component.exports